import React, { useState, useContext, useEffect } from "react";
import pumpBackgroundGlow from "../resources/btn_background_blue_glow_circle.png";
import pumpConfig from "../resources/icon_config.png";
import BlowerModal from "./BlowerModal";
import blowerIcon from "../resources/icon_blower.png";
import { MainContext } from "../../context/MainContext";
import * as Constants from "../../components/api/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

let deviceId = 0;
let speed = 0;

const ControlBlowers = () => {
  const state = useContext(MainContext).state;
  deviceId = state.selectedDevice;

  const r6 = state.R6.split(",");
  const rc = state.RC.split(",");

  speed = r6[1];

  let blowerId = 1;
  if (parseInt(rc[10]) === 0) blowerId = 2;
  else if (parseInt(rc[10]) === 1) blowerId = 3;

  const [blowerMode, setBlowerMode] = useState(blowerId);
  const [showBlowerModal, setShowBlowerModal] = useState(false);

  useEffect(() => {
    setBlowerMode(blowerId);
  }, [blowerId]);

  const sendCommand = (command, value) => {
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: value,
      }),
      credentials: "include",
    };

    fetch(Constants.baseURL + Constants.apiSendCommand, requestOptions)
      .then((response) => {
        if (response.ok) {
          toast.success("Command sent successfully. Refreshing...", {
            position: "top-right",
            autoClose: 10000,
          });

          setTimeout(() => state.refreshDeviceRF(deviceId), 8000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 12000);
        } else {
          toast.error("Send failed. Please try again", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      })
      .catch((error) => console.log("request failed", error));
  };

  return (
    <>
      <ToastContainer />

      {/* Title */}
      <Typography
        component="h2"
        variant="h6"
        sx={{ color: "white", fontWeight: 600, mb: 1 }}
      >
        Blower
      </Typography>

      {/* TILE WRAPPER */}
      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.08)",
          width: "100%",
        }}
      >
        {/* Keep original blower UI */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            onClick={() => setShowBlowerModal(true)}
            style={{
              width: "60px",
              height: "60px",
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            {/* glow */}
            <img
              src={pumpBackgroundGlow}
              alt="Blower glow"
              style={{
                width: "80px",
                height: "80px",
                objectFit: "contain",
              }}
            />

            {/* blower icon */}
            <img
              src={blowerIcon}
              alt="Blower icon"
              style={{
                width: "28px",
                height: "28px",
                position: "absolute",
              }}
            />

            {/* config bubble */}
            <div
              style={{
                position: "absolute",
                top: "-1px",
                right: "-1px",
                width: "23px",
                height: "23px",
                borderRadius: "50%",
                backgroundColor: "#1E1E1E",
                border: "2px solid #2B333C",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={pumpConfig}
                alt="Settings"
                style={{ width: "12px", height: "12px" }}
              />
            </div>
          </div>
        </Box>
      </Paper>

      {/* Modal */}
      {showBlowerModal && (
        <BlowerModal
          blowerName="Blower"
          blowerStatus={blowerMode}
          blowerSpeed={speed}
          sendCommand={sendCommand}
          onClose={() => setShowBlowerModal(false)}
        />
      )}
    </>
  );
};

export default ControlBlowers;
